export const validationRules: any = {

    item_condition: {
        required: true,
    },
    conditionRemark: {
        required: true,
    },

    sku: {
        required: true,
    },

};